import React , {Component} from "react";
import Logo from '../../assets/Footer/LOGO BLANC.svg';
import './styles.css'
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from "@fortawesome/free-solid-svg-icons";

export class Footer extends Component{
    constructor(props) {
        super(props);
    }
    render(){
        return(
           <React.Fragment>
               <div  className="row pt-lg-5 footer pb-4 pb-lg-0" style={{  backgroundColor : '#000000',borderBottom : '2px solid #707070' , marginRight :'0' , marginLeft : '0'}}>
                   <div id="logoDiv" className="mb-3 mt-2 mb-lg-0 mt-lg-0 pt-4 pb-4 pt-lg-0 pb-lg-0 col-12 col-lg-3">
                       <img id="logo" src={Logo}/>
                   </div>
                   <div className="footerSection col-6 col-lg-3">
                       <div className='col pb-lg-5'>
                           <div className='footerTitle pb-lg-3'>CLIENT</div>
                           <div className="footerContent"> <Link  to={'/client'}>C'est quoi ADSIL RIDER ?</Link> </div>
                           <div className="footerContent"><Link  to={'/FAQ'}> Questions fréquentes</Link></div>
                       </div>
                       <div id="contactSectionFooter" className='offset-6 offset-lg-0 footerSection col pb-lg-3 '>
                           <div className='footerTitle pb-lg-3'>Contacter-Nous</div>
                           <div className="footerContent"> <a href ="mailto: support@adsil.io">support@adsil.io</a></div>
                           <div className="footerContent"> 0798779631</div>
                       </div>
                   </div>
                   <div className=" col-6 col-lg-3">
                       <div className='col footerSection'>
                           <div className='footerTitle pb-lg-3'>PARTENAIRE</div>
                           <div className="footerContent"> <Link to={'/partenaire'}> C'est quoi ADSIL DRIVER</Link></div>
                           <div className="footerContent"><Link to={'/FAQ'}>Questions fréquentes</Link></div>
                       </div>
                   </div>
                   <div id="suivezNousSectionFooter" className="offset-3 offset-lg-0 col-6 col-lg-3 pr-0 ">
                       <div className="footerTitle mb-2 m-lg-0"> Suivez-nous</div>
                       <div id="footerIcons">
                           <a target="_blank" href="https://www.facebook.com/adsil.dz"><i  className="fa fa-facebook pr-3"/></a>
                           <a target="_blank" href="https://www.instagram.com/adsil.dz/">  <i className="fa fa-instagram pr-3"/></a>
                           {/*<a href="#"><i className="fa fa-linkedin pr-3"/></a>*/}
                           <a target="_blank" href="https://www.youtube.com/channel/UClxH0487w-p8EDNWR59hpjw"><i className="fa fa-youtube pr-3"/></a>
                       </div>
                   </div>
               </div>
               <div className="footer" style={{ backgroundColor :'#000000'}}>
                   <nav  id='footerNavbar' className="navbar navbar-expand-sm">
                       {/*<a id='footerBrand' className="navbar-brand ml-5" href="#" style={{fontSize : '1rem'}}>Quizo.com Copyright © 2020</a>*/}
                       <ul id='navFooter' className="navbar-nav ml-auto" style={{fontSize : '1.1rem'}}>
                           <li id="footerSec1"  className="nav-item  footerItem d-lg-flex">
                               <div>
                                   <Link id="termes" className="nav-link footerTitle" to="/privacy-policy">TERMES ET CONDIIONS</Link>
                               </div>
                           </li>
                       </ul>
                   </nav>
               </div>
           </React.Fragment>

        )
    }
}